var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Prefix"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/lock"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5 8.83341V7.16675C5 4.40841 5.83333 2.16675 10 2.16675C14.1667 2.16675 15 4.40841 15 7.16675V8.83341",
    stroke: "#B9C0D4",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.99935 15.9167C11.1499 15.9167 12.0827 14.9839 12.0827 13.8333C12.0827 12.6827 11.1499 11.75 9.99935 11.75C8.84876 11.75 7.91602 12.6827 7.91602 13.8333C7.91602 14.9839 8.84876 15.9167 9.99935 15.9167Z",
    stroke: "#B9C0D4",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.166 18.8333H5.83268C2.49935 18.8333 1.66602 17.9999 1.66602 14.6666V12.9999C1.66602 9.66659 2.49935 8.83325 5.83268 8.83325H14.166C17.4993 8.83325 18.3327 9.66659 18.3327 12.9999V14.6666C18.3327 17.9999 17.4993 18.8333 14.166 18.8333Z",
    stroke: "#B9C0D4",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.ea9918894de92095f4e4cfc5f2820760.svg";
export { ForwardRef as ReactComponent };